<template>
  <div class="trf-simple-slider" :class="`is-${tipoDeTransicao}`">
    <div v-if="!!titulo" class="trf-simple-slider-header" @click="inicializar">
        <p class="has-text-centered is-size-5">{{titulo}}</p>
    </div>
    <div class="trf-simple-slider-main">
      <div v-if="exibeControles" class="trf-simple-slider-prev">
        <button @click="_slideAnterior" class="mr-1 button is-rounded is-primary px-3">
          <FontAwesomeIcon icon="fa-angle-left"/>
        </button>
      </div>
      <div class="trf-simple-slider-slides">
        <div class="trf-simple-slider-slide-frame" :style="_adquirirEstiloDoQuadro()">
          <slot />
        </div>
      </div>
      <div v-if="exibeControles" class="trf-simple-slider-next">
        <button @click="_slideSeguinte" class="ml-1 button is-rounded is-primary px-3">
          <FontAwesomeIcon icon="fa-angle-right"/>
        </button>
      </div>
    </div>
    <div v-if="exibePaginas" class="trf-simple-slider-footer">
        <div class="trf-simple-slider-pager is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-center is-align-items-center">
            <button class="mx-1 button is-rounded trf-is-bullet" :class="this.paginaAtual == index+1? 'is-primary' : ''" v-for="(slide, index) in this.slides" :key="slide" @click="_fazerTransicao(index+1)"></button>
        </div>
    </div>
  </div>
</template>
<script>
import {utils} from '../../util/utils';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "TrfSimpleSlider",
  components: {
    FontAwesomeIcon
  },
  props: {
    titulo: String,
    exibeControles: {
      type: Boolean,
      default: true
    },
    exibePaginas: {
      type:Boolean,
      default: true
    },
    permiteLoop: {
      type:Boolean,
      default: true,
      required: false
    },
    maxFrameHeight: {
      type:String,
      required: false
    },
    tipoDeTransicao: {
      type:String,
      default: 'slide',
      required: false,
      validator: (valor) => {
        const transicoesValidas = ['slide', 'fade'];
        const isTransicaoValida = transicoesValidas.includes(valor);
        return isTransicaoValida;
      }
    },
    emitirEventosDeControle: {
      type:Boolean,
      default: false,
      required: false
    },
  },

  data() {
    return {
      slides: [],
      paginaAtual: 1,
      paginasTotais: 1,
      desabilitarTransicao: false
    };
  },

  methods: {
    _adquirirElementoDoQuadro() {
      const slider = this.$el;
      const frame = slider.querySelector('.trf-simple-slider-slide-frame');

      return frame;
    },
    _iniciarControles() {
      const frame = this._adquirirElementoDoQuadro();
      const qntSlides = frame.childElementCount;
      const qntPadronizada = qntSlides == 0? 1 : qntSlides;
      const slidesEls = Array.from(frame.children);

      this.slides = slidesEls;
      this.paginasTotais = qntPadronizada;
    },
    _adquirirEstiloDoQuadro() {
      if(this.tipoDeTransicao == 'fade') return;
      let style = '';
      if(!!this.maxFrameHeight) {
        style += `max-height:${this.maxFrameHeight};`;
      }
      style += `width: ${this.paginasTotais * 100}%;`;

      return style;
    },
    _definirTamanhoDoSlide() {
      if(this.tipoDeTransicao == 'fade') return;
      const width = `${100 / this.paginasTotais}%`;

      return width;
    },
    async _iniciarEstilosSlider() {
      if(this.tipoDeTransicao == 'slide') {
        const slider = this.$el;
        const tamanho = this._definirTamanhoDoSlide();
        const slides = Array.from(slider.querySelectorAll('.trf-simple-slider-slide-frame > *'))
        slides.forEach(el => {
          el.style.width = tamanho;
        })
      } else {
        //atualmente, fade
        const primeiroSlide = this.slides[0];
        await this._definirAlturaDinamica();
        primeiroSlide.classList.add('is-active');
      }
    },
    async _definirAlturaDinamica() {
      const slideAtualElement = this.slides[this.paginaAtual - 1];
      const retryer = await utils.retry(() => slideAtualElement.clientHeight > 0, 200, 1, 20);

      if(!retryer) return;

      const slideAtualHeight = slideAtualElement.clientHeight;
      const quadro = this._adquirirElementoDoQuadro();
      quadro.style.height = `${slideAtualHeight}px`;
    },
    _slideSeguinte() {
      const slideSeguinte = (this.paginaAtual + 1) > this.paginasTotais? 1 : this.paginaAtual + 1;
      this._fazerTransicao(slideSeguinte);
    },
    _slideAnterior() {
      const slideAnterior = (this.paginaAtual - 1) < 1? this.paginasTotais : this.paginaAtual - 1;
      this._fazerTransicao(slideAnterior);
    },
    _fazerTransicao(slideEsperado = 1, ignorarEvento = false) {
      if(this.emitirEventosDeControle && !ignorarEvento) {
        this.$emit('slideChange', slideEsperado)
      }

      if(this.tipoDeTransicao == 'slide') {
        const primeiroSlide = this.slides[0];
        const tamanhoPorSlide = this._definirTamanhoDoSlide().replace("%",'');
        const distancia = slideEsperado == 1? 0 : `${tamanhoPorSlide * (slideEsperado - 1)}%`;
        primeiroSlide.style.marginLeft = `-${distancia}`;
        this.paginaAtual = slideEsperado;
      } else {
        //atualmente, fade
        const slideEsperadoElement = this.slides[slideEsperado - 1];
        const slideAnteriorElement = this.slides[this.paginaAtual-1];
        slideAnteriorElement.classList.remove('is-active');
        slideEsperadoElement.classList.add('is-active');
        this._definirAlturaDinamica();
        this.paginaAtual = slideEsperado;
      }
    },
    _criarObservadorDeSlot() {
      const observer = new MutationObserver(this._updateSlider);
      observer.observe(this.$el, {
        childList: true,
        subtree: true 
      });
      this.observer = observer;
    },
    _updateSlider() {
      this._iniciarControles();
      this._iniciarEstilosSlider();
      this._fazerTransicao(this.paginaAtual, true);
    },
  },
  mounted() {
    this._iniciarControles();
    this._iniciarEstilosSlider();
    this._criarObservadorDeSlot();
    if(this.tipoDeTransicao == 'slide') {
      window.addEventListener('resize', this._iniciarEstilosSlider)
    }
  },
  beforeUnmount() {
    if(this.tipoDeTransicao == 'slide') {
      window.removeEventListener('resize', this._iniciarEstilosSlider)
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";

.trf-simple-slider {
  display: flex;
  flex-direction: column;
  &-main {
    display: flex;
    flex-direction: row;
  }
  &-slides {
    width:100%;
    overflow:hidden;
  }
  &-slide-frame {
    min-width:100%;
  }
  &-prev, &-next {
    display:flex;
    align-items: center;
    button {
      margin-top:-72px;
    }
  }
  .trf-is-bullet {
    width: 1.5em!important;
    height: 1.5em!important;
    padding: 0!important;
    line-height: 0!important;
  }
}
</style>
<style lang="scss">
// Regras que afetam slots preferencialmente devem ser globais para evitar colateral
  .trf-simple-slider {
    &.is-slide {
      transition:0.25s ease-out 0s;
      .trf-simple-slider-slide-frame  > * {
        display:inline-block;
        overflow:hidden;
        transition:0.25s ease-out 0s;
      }
    };
    &.is-fade {
      transition:0.25s ease-out 0s;
      .trf-simple-slider-slide-frame {
        position: relative;
        width:100%;
        height:auto;
        & > * {
          transition:0.25s ease-out 0s;
          position:absolute;
          opacity: 0;
          pointer-events:none;
          width:100%;
          &.is-active {
            opacity: 1;
            pointer-events:auto;
          }
        }
      }
    };
  }
</style>